import { createSlice } from "@reduxjs/toolkit";
import { GeneralSliceInterface } from "interfaces/serviciosGenerales/serviciosGeneralesInterface";

export const generalesSlice = createSlice({
  name: "generalesSlice",
  initialState: {
    lstJuzgados: [],
    tipoPenal: false,
    lstMateriasOr: [],
    lstInstanciasOr: [],
    lstTiposCarpetas: [],
    materiaSelected: null,
    carpetaJudicial: null,
    materiasOficialia: [],
    instanciasOficialia: [],
    adscripcionSelected: null,
    juzgadosOrdinariosEnLinea: [],
    datosBusquedaCarpetaJudicial: null,
    juzgadosExpedientesAutorizados: [],
    fechaLiberacion: null,
    cveLitiDisabled: false,
    cveModalidadDisabled: false,
    expedienteSelect: null,
    videoAyuda: null,
    datosBusqueda: null
  } as GeneralSliceInterface,
  reducers: {
    onLoadJuzgado: (state, { payload }) => {
      state.lstJuzgados = payload;
    },
    onLoadMaterias: (state, { payload }) => {
      state.lstMateriasOr = payload;
    },
    onLoadTipoPenal: (state) => {
      state.tipoPenal = !state.tipoPenal;
    },
    onResetBusquedaCarpeta: (state) => {
      state.carpetaJudicial = null;
      state.datosBusquedaCarpetaJudicial = null;
    },
    onLoadTiposCarpetas: (state, { payload }) => {
      state.lstTiposCarpetas = payload;
    },
    onLoadMateriaSelected: (state, { payload }) => {
      state.materiaSelected = payload;
    },
    onLoadCarpetaJudicial: (state, { payload }) => {
      state.carpetaJudicial = payload;
    },
    onLoadMateriasOficialia: (state, { payload }) => {
      state.materiasOficialia = payload;
    },
    onLoadInstanciasOficialia: (state, { payload }) => {
      state.instanciasOficialia = payload;
    },
    onLoadAdscripcionSelected: (state, { payload }) => {
      state.adscripcionSelected = payload;
    },
    onLoadDatosBusquedaCarpeta: (state, { payload }) => {
      state.datosBusquedaCarpetaJudicial = payload;
    },
    onLoadJuzgadosOrdinariosEnLinea: (state, { payload }) => {
      state.juzgadosOrdinariosEnLinea = payload;
    },
    onLoadInstanciasOrdinariasEnLinea: (state, { payload }) => {
      state.lstInstanciasOr = payload;
    },
    onDisabledLitiModalidad: (state, { payload }) => {
      state.cveLitiDisabled = payload.cveLitiDisabled;
      state.cveModalidadDisabled = payload.cveLitiDisabled;
      state.fechaLiberacion = payload.fechaLiberacion;
    },
    onSelectExpediente: (state, { payload }) => {
      state.expedienteSelect = payload;
    },
    onLoadVideoAyuda: (state, { payload }) => {
      state.videoAyuda = payload;
    },
    onResetCarpetaJudicial: (state) => {
      state.lstJuzgados = [];
      state.tipoPenal = false;
      state.lstMateriasOr = [];
      state.lstInstanciasOr = [];
      state.lstTiposCarpetas = [];
      state.materiaSelected = null;
      state.carpetaJudicial = null;
      state.materiasOficialia = [];
      state.instanciasOficialia = [];
      state.adscripcionSelected = null;
      state.juzgadosOrdinariosEnLinea = [];
      state.datosBusquedaCarpetaJudicial = null;
      state.juzgadosExpedientesAutorizados = [];
      state.expedienteSelect = null;
      state.datosBusqueda = [];
    },
    setJuzgadosExpedientesAutorizados: (state, { payload }) => {
      state.juzgadosExpedientesAutorizados = payload;
    },
    onDatosBusqueda: (state, { payload }) => {
      state.datosBusqueda = payload;
    },
  },
});

export const {
  onLoadJuzgado,
  onLoadMaterias,
  onLoadTipoPenal,
  onLoadTiposCarpetas,
  onLoadCarpetaJudicial,
  onLoadMateriaSelected,
  onResetBusquedaCarpeta,
  onResetCarpetaJudicial,
  onLoadMateriasOficialia,
  onLoadAdscripcionSelected,
  onLoadInstanciasOficialia,
  onLoadDatosBusquedaCarpeta,
  onLoadJuzgadosOrdinariosEnLinea,
  onLoadInstanciasOrdinariasEnLinea,
  setJuzgadosExpedientesAutorizados,
  onDisabledLitiModalidad,
  onSelectExpediente,
  onLoadVideoAyuda,
  onDatosBusqueda,
} = generalesSlice.actions;
